<template>
  <!-- 藏品专题详情 -->
  <div class="page-collect-topic-detail">
    <div class="g-content-wrap">
      <!-- <div class="slides-box">
        <div class="pic-box">
          <img v-lazy="detailData.headUrl" alt="">
        </div>
        <div class="pic-info">
          <h2 class="title mb-10">{{detailData.personName}}</h2>
          <p class="p-wrapper"><span class="label">职业：</span><span class="span2">{{detailData.job}}</span></p>
          <p class="p-wrapper"><span class="label">出生日期：</span><span class="span2">{{detailData.birth}}</span></p>
          <p class="p-wrapper"><span class="label">籍贯：</span><span class="span2">{{detailData.personNative}}</span></p>
        </div>
      </div> -->

      <div>
        <h1 class="h-title">人物介绍</h1>
        <div class="g-detail-html trans" v-html="detailData.introduce"></div>

      </div>

    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      detailId: this.$route.query.id,
      detailData: { },
    }
  },
  methods: {
    getDetailData() {
      this.$http
        .get('/api/person/detail.do', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.detailData = res.data

          } else {
            this.$message.error(res.message)
          }
        })
    },
  },
  created() {
    this.getDetailData()
  }
}
</script>

<style lang="scss" scoped>
.page-collect-topic-detail {
  padding-top: $headerHeight;
  background: url(../../assets/images/home/bg_cover.png) no-repeat center;
  background-size: 100% 100%;
  .slides-box {
    margin-bottom: 40px;
    display: flex;
    .pic-box {
      flex-basis: 400px;
      flex-shrink: 0;
      margin-right: 20px;
      img {
        width: 100%;
        height: 400px;
      }
    }
    .pic-info {
      flex: 1;
      position: relative;
      .p-wrapper {
        display: flex;
        font-size: 14px;
        line-height: 24px;
        margin-top: 10px;
        .label {
          flex-shrink: 0;
          color: #7f7f7f;
        }
      }
      h2 {
        font-weight: 600;
        font-size: 24px;
        margin-bottom: 24px;
      }
    }
  }

  .h-title {
    font-size: 24px;
    font-weight: 600;
    color: #000;
    margin-bottom: 20px;
  }
}
</style>

